import Vue from 'vue';
import Components from 'bc-ui';
import 'bc-ui/src/assets/styles/index.scss';

Vue.use(Components);
